<template>
  <div style="display: flex;flex-wrap: wrap" class="box">
    <div>
      <span>空气温度</span>
      <span>{{monitor.a191}}℃</span>
    </div>
    <div >
      <span>空气湿度</span>
      <span> {{monitor.a192}}%RH</span>
    </div>
    <div >
      <span>一氧化碳</span>
      <span>{{monitor.a216}}ppm</span>
    </div>
    <div>
      <span>二氧化碳</span>
      <span>{{monitor.a217}}ppm</span>
    </div>
    <div>
      <span>光照强度</span>
      <span>{{monitor.a218}}Lux</span>
    </div>
    <div>
      <span>大气压力</span>
      <span>{{monitor.a195}}Kpa</span>
    </div>
    <div>
      <span>土壤温度</span>
      <span>{{monitor.a189}}℃</span>
    </div>
    <div>
      <span>土壤湿度</span>
      <span>{{monitor.a190}}%RH</span>
    </div>
    <div>
      <span>土壤EC值</span>
      <span>{{monitor.a191}}us/cm</span>
    </div>
  </div>
</template>
<script>
  import { monitorData } from '@/api/demo.js'
  export default {
    name: 'house',
    props: {
      sn:{
        type:String,
        required:false
      }
    },
    data() {
      return {
        monitor:{}
      }
    },
    mounted() {
     this.monitorDataGet()
      let time=null
      time = setInterval(()=>{
        this.monitorDataGet()
      },60000)
    },
    methods: {
      monitorDataGet() {
        monitorData(this.sn).then(data=>{
          this.monitor=data
          console.log(data)
        })
      }
    }
  }
</script>
<style scoped>
  .box > div{
    margin-right:10px ;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitor/MonitorDemo/House.vue